import {inject, Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {combineLatest, filter, map, Observable, startWith} from 'rxjs';
import {EVENT_BUS} from 'src/app/shared/domain/tokens/event-bus.token';
import {
  BookingTicketGeneratedEvent
} from '../../../../../shared/application/events/ticket/booking-ticket-generated.event';

import {IEntryViewerViewState} from '../view-states/entry-viewer.view-state';
import {EntryViewerMapper} from '../mapper/entry-viewer.mapper';
import {GetActiveBookingUseCase} from '../../../booking/application/use-cases/get-active-booking.use-case';

@Injectable({providedIn: 'root'})
export class EntryViewerStateHandler {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly getActiveBooking = inject(GetActiveBookingUseCase);
  private readonly router = inject(Router);

  readonly activeBooking$ = this.getActiveBooking.execute();

  private readonly ticketGenerated$ = this.eventBus
    .ofType(BookingTicketGeneratedEvent)
    .pipe(startWith(undefined));

  private readonly currentUrl$ = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map((event: NavigationEnd) => event.url),
    startWith(this.router.url)
  );

  getViewState(isOffline$: Observable<boolean>): Observable<IEntryViewerViewState> {
    return combineLatest([
      this.activeBooking$,
      this.ticketGenerated$,
      isOffline$.pipe(startWith(false)),
      this.currentUrl$,
    ]).pipe(
      map(([booking, ticket, offline, currentUrl]) =>
        EntryViewerMapper.mapToState(booking, ticket, offline, currentUrl)
      )
    );
  }
}
